module.exports = __webpack_public_path__ + "static/img/whys-Outer.f9cafd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whys-Outer.jpg
// module id = Xw+v
// module chunks = 1